/// <amd-module name="Repos/Views/Settings/Options/Components/SuggestionCard" />
import React = require("react");
import { IOption } from "Repos/Views/Settings/Options/Contracts/Contracts";
import * as Resources from "Repos/Views/Settings/Options/Resources";
import { IObservableValue, ObservableValue } from "VSS/Core/Observable";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";
import { Card } from "VSSUI/Card";
import { FormItem } from "VSSUI/FormItem";
import { Observer } from "VSSUI/Observer";
import { Pill, PillSize, PillVariant } from "VSSUI/Pill";
import { PillGroup, PillGroupOverflow } from "VSSUI/PillGroup";
import { TextField } from "VSSUI/TextField";
import { IOptionsViewService } from "../Services/OptionsViewService";

interface ISuggestionCardProps {
    option: IOption;
    suggestionFieldInitial: string;
    projectId: string;
    repositoryId: string | undefined;
    optionsSvc: IOptionsViewService;
}

interface ISuggestionCardState {
    disableSaveBtn: boolean;
}

export class SuggestionCard extends VssComponent<ISuggestionCardProps, ISuggestionCardState> {

    private suggestionField: IObservableValue<string>;
    private readonly allowedOptions: { [key: string]: string } = {
        "userAlias": "{userAlias}",
        "workitemId": "{workitemId}"
    };
    private textValidationError: IObservableValue<string | undefined>;

    public constructor(props: ISuggestionCardProps, context: IVssComponentContext) {
        super(props, context);

        this.state = {
            disableSaveBtn: true
        };
        this.suggestionField = new ObservableValue(this.props.suggestionFieldInitial);
        this.textValidationError = new ObservableValue("");
    }

    public render = (): JSX.Element => {
        let pills: JSX.Element | JSX.Element[] = [];

        for (let key in this.allowedOptions) {
            pills.push(
                <Pill key={key} variant={PillVariant.outlined} size={PillSize.compact} onClick={() => this.suggestionField.value = this.suggestionField.value + this.allowedOptions[key]}>{key}</Pill>
            );
        }

        return (
            <Card className="flex-grow policies" titleProps={{ text: Resources.SuggestionSettings }} contentProps={{ contentPadding: false }}>
                <div className="policy-toggle flex-row padding-vertical-16 padding-horizontal-20">
                    <Observer validationError={this.textValidationError}>
                        {({ validationError }: { validationError: string | undefined }) => (
                            <FormItem error={Boolean(validationError)} message={validationError}>
                                <TextField
                                    disabled={false}
                                    onChange={this._onSuggestionCardChange}
                                    value={this.suggestionField}
                                    className="bolt-textfield-default-width"
                                />
                            </FormItem>
                        )}
                    </Observer>
                </div>
                <div className="policy-toggle padding-vertical-16 padding-horizontal-20">
                    <PillGroup className="flex-row" overflow={PillGroupOverflow.wrap}>
                        {pills}
                    </PillGroup>
                </div>
                <div className="policy-toggle padding-vertical-16 padding-horizontal-20">
                    <div className="saveBtn">
                        <Button
                            primary={true}
                            disabled={this.state.disableSaveBtn}
                            onClick={this._onSuggestionSave}
                        >
                            {Resources.Save}
                        </Button>
                    </div>
                </div>
            </Card>);
    };

    private _onSuggestionCardChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, value: string): void => {
        this.suggestionField.value = value;
        this.setState({ disableSaveBtn: false });
    };

    private _onSuggestionSave = async () => {
        this.setState({ disableSaveBtn: true });
        const { validationError } = await this.props.optionsSvc.toggleRepositoryOption(this.props.option, this.props.projectId, this.props.repositoryId, this.suggestionField.value);
        this.textValidationError.value = validationError;
    }

}
